/**
 * TanStack Query (Vue Query) Configuration
 *
 * Configures the query client with sensible defaults for
 * server state management, caching, and automatic refetching.
 */
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query';
import type { App } from 'vue';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 5 minutes
      staleTime: 1000 * 60 * 5,

      // Keep unused data in cache for 10 minutes
      gcTime: 1000 * 60 * 10,

      // Retry failed requests 1 time
      retry: 1,

      // Refetch on window focus in production only
      refetchOnWindowFocus: import.meta.env.PROD,

      // Refetch on reconnect
      refetchOnReconnect: true,

      // Refetch on mount if data is stale
      refetchOnMount: true,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
});

export function setupVueQuery(app: App) {
  app.use(VueQueryPlugin, {
    queryClient,
    enableDevtoolsV6Plugin: true,
  });

  return queryClient;
}

export { queryClient };
